"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resultViewModel = resultViewModel;
function sortByOrder(items) {
    const withOrder = items.filter((item) => item.order !== undefined);
    const withoutOrder = items.filter((item) => item.order === undefined);
    withOrder.sort((a, b) => a.order - b.order);
    return [...withOrder, ...withoutOrder];
}
function getRespondentValue(candidateId, candidatesAnswersMap) {
    const answers = candidatesAnswersMap.get(candidateId);
    if (!answers?.length)
        return "candidate";
    const respondents = new Set(answers.map((answer) => answer.respondent));
    if (respondents.size > 1) {
        return "mixed";
    }
    return respondents.values().next().value ?? "candidate";
}
function resultViewModel(candidates, candidatesAnswers, algorithmMatches) {
    const candidatesAnswersMap = new Map(Object.entries(candidatesAnswers));
    const topLevelIds = candidates.map((candidate) => candidate.id);
    const topLevelAlgorithmMatches = algorithmMatches.filter((match) => topLevelIds.includes(match.id));
    const matches = candidates.map((candidate) => {
        const matchIndex = topLevelAlgorithmMatches.findIndex((match) => match.id === candidate.id);
        const match = matchIndex >= 0 ? topLevelAlgorithmMatches[matchIndex]?.match : undefined;
        const order = match !== undefined ? topLevelAlgorithmMatches.filter((match) => match.match !== undefined).findIndex((validMatch) => validMatch.id === candidate.id) + 1 : undefined;
        let nestedMatches;
        if (candidate.nestedCandidates && candidate.nestedCandidates.length > 0) {
            const nestedIds = candidate.nestedCandidates.map((nestedCandidate) => nestedCandidate.id);
            const nestedAlgorithmMatches = algorithmMatches.filter((match) => nestedIds.includes(match.id));
            nestedMatches = candidate.nestedCandidates.map((nestedCandidate) => {
                const nestedMatchIndex = nestedAlgorithmMatches.findIndex((match) => match.id === nestedCandidate.id);
                const nestedMatch = nestedMatchIndex >= 0 ? nestedAlgorithmMatches[nestedMatchIndex]?.match : undefined;
                const nestedOrder = nestedMatch !== undefined ? nestedAlgorithmMatches.filter((match) => match.match !== undefined).findIndex((validMatch) => validMatch.id === nestedCandidate.id) + 1 : undefined;
                return {
                    candidate: nestedCandidate,
                    match: nestedMatch,
                    order: nestedOrder,
                    respondent: getRespondentValue(nestedCandidate.id, candidatesAnswersMap),
                    candidateAnswers: candidatesAnswersMap.get(nestedCandidate.id) || [],
                };
            });
            nestedMatches = sortByOrder(nestedMatches);
        }
        return {
            candidate,
            match,
            order,
            respondent: getRespondentValue(candidate.id, candidatesAnswersMap),
            candidateAnswers: candidatesAnswersMap.get(candidate.id) || [],
            nestedMatches,
        };
    });
    return { matches: sortByOrder(matches) };
}
